export default "__VITE_ASSET__BpahNrta__"